module.exports = __webpack_public_path__ + "static/schedule_day-41de6c0faa344e9f08a06ce73f4d62b1.png";